import { pxToRem } from "@mos-cat/ds-theme";
import { WHCM } from "../../constants";

export const customStyles = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  lineHeight: 1.5,

  "input[type='search']&": {
    borderRadius: "fieldBorderRadius",
  },
  "select&": {
    minHeight: pxToRem(48),
    py: "0.7rem",
    "-moz-appearance": "none",
    "-webkit-appearance": "none",
    appearance: "none",

    pr: "2em",
    backgroundImage: `url('data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 32 32"%3E%3Cpath fill="%230E0E0F" d="M15.9999 18.7322L24.9999 9.73218L26.7677 11.4999L16.8838 21.3838C16.6494 21.6183 16.3314 21.75 15.9999 21.75C15.6684 21.75 15.3505 21.6183 15.116 21.3838L5.23218 11.4999L6.99995 9.73218L15.9999 18.7322Z"/%3E%3C/svg%3E')`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "1.5rem auto",
    backgroundPosition: "center right 0.6875em",

    "&[aria-disabled='true'], &[aria-disabled='true']:focus, &[aria-disabled='true']:focus:hover": {
      backgroundImage: `url('data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 32 32"%3E%3Cpath fill="%23696C71" d="M15.9999 18.7322L24.9999 9.73218L26.7677 11.4999L16.8838 21.3838C16.6494 21.6183 16.3314 21.75 15.9999 21.75C15.6684 21.75 15.3505 21.6183 15.116 21.3838L5.23218 11.4999L6.99995 9.73218L15.9999 18.7322Z"/%3E%3C/svg%3E')`,
      borderColor: "fieldDisabledBorderColor",
      backgroundColor: "fieldDisabledBgColor",
      color: "fieldDisabledTextColor",
      pointerEvents: "none",
      opacity: 1,
    },
  },

  "textarea&": {
    overflow: "auto",
  },

  "&:hover": {
    borderColor: "fieldHoverBorderColor",
    backgroundColor: "fieldHoverBgColor",
  },
  "&::placeholder": {
    color: "fieldPlaceholderColor",
    opacity: 1,
  },
  "&:-ms-input-placeholder": {
    color: "fieldPlaceholderColor",
    opacity: 1,
  },
  "&:-moz-placeholder": {
    color: "fieldPlaceholderColor",
    opacity: 1,
  },
  "&::-webkit-input-placeholder": {
    color: "fieldPlaceholderColor",
    opacity: 1,
  },

  "&:focus": {
    borderColor: "fieldFocusBorderColor",
    backgroundColor: "fieldBgColor",
    boxShadow: "focus",
  },
  "&:hover:focus": {
    borderColor: "fieldFocusBorderColor",
    backgroundColor: "fieldBgColor",
  },
  "&[aria-disabled='true'], &[aria-disabled='true']:focus, &[aria-disabled='true']:focus:hover": {
    borderColor: "fieldDisabledBorderColor",
    backgroundColor: "fieldDisabledBgColor",
    color: "fieldDisabledTextColor",
    pointerEvents: "none",
  },

  "&[aria-disabled='true']:-ms-input-placeholder": {
    color: "fieldDisabledTextColor",
    opacity: 1,
  },
  "&[aria-disabled='true']:-moz-placeholder": {
    color: "fieldDisabledTextColor",
    opacity: 1,
  },
  "&[aria-disabled='true']::-webkit-input-placeholder": {
    color: "fieldDisabledTextColor",
    opacity: 1,
  },

  [WHCM]: {
    "&, &:hover": {
      borderColor: "WindowText",
      color: "WindowText",
      backgroundColor: "Window",
    },

    "&::placeholder": {
      color: "GrayText",
    },
    "&:-ms-input-placeholder": {
      color: "GrayText",
    },
    "&:-moz-placeholder": {
      color: "GrayText",
    },
    "&::-webkit-input-placeholder": {
      color: "GrayText",
    },
    "&:focus": {
      outline: "0.25rem solid auto",
    },
    "&[aria-disabled='true'], &[aria-disabled='true']:focus, &[aria-disabled='true']:focus:hover": {
      borderColor: "GrayText",
      color: "GrayText",
    },
    "select&": {
      backgroundImage: "none",
      "-moz-appearance": "auto",
      "-webkit-appearance": "auto",
      appearance: "auto",

      "&[aria-disabled='true'], &[aria-disabled='true']:focus, &[aria-disabled='true']:focus:hover":
        {
          backgroundImage: "none",
          borderColor: "GrayText",
          color: "GrayText",
        },
    },
  },
};
